'use client';

import { Typography, Button, Card, CardContent, Stack } from '@mui/material';
import Image from 'next/image';
import { signIn } from 'next-auth/react';

import { Illustrations } from '@/components/Illustrations';
import { themeConfig } from '@/configs/themeConfig';

const LoginV1 = () => {
  const lightImg = '/statics/images/pages/auth-v2-mask-light.png';
  const authBackground = lightImg;

  return (
    <div className='flex flex-col items-center min-bs-[100dvh] relative p-6'>
      <Card className='flex flex-col sm:is-[450px]'>
        <CardContent className='p-12!'>
          <div className='flex flex-col gap-5'>
            <Stack gap='12px'>
              <Typography variant='h2'>{`Welcome to ${themeConfig.templateName}!👋🏻`}</Typography>
              <Typography variant='body1' className='mbs-1'>
                Please sign-in to your account and start the adventure
              </Typography>
            </Stack>
            <form
              noValidate
              autoComplete='off'
              onSubmit={(e) => e.preventDefault()}
              className='flex flex-col gap-5'
            >
              <div className='flex justify-center items-center gap-2'>
                <Button
                  color='secondary'
                  className='self-center text-(--mui-palette-text-primary)'
                  startIcon={
                    <Image
                      src='/statics/images/logos/google.png'
                      alt='Google'
                      width={22}
                      height={22}
                    />
                  }
                  sx={{ '& .MuiButton-startIcon': { marginInlineEnd: 3 } }}
                  onClick={() => void signIn('google')}
                >
                  Sign in with Google
                </Button>
              </div>
            </form>
          </div>
        </CardContent>
      </Card>
      <Illustrations maskImg={{ src: authBackground }} />
    </div>
  );
};

export { LoginV1 };
